export const TYPES = {
  ADD_PRICE_LIST: 'ADD_PRICE_LIST',
  CHANGE_PRICE: 'CHANGE_PRICE',
  CHANGE_PRICE_LIST_NAME: 'CHANGE_PRICE_LIST_NAME',
  DELETE_PRICE_LIST: 'DELETE_PRICE_LIST'
}
